module.exports = __webpack_public_path__ + "img/layer.6bc7a8ea.png";